export default __webpack_public_path__ + "locales/zh-CN/PrivacyPage.json?hash=ec4e7f67e332481e6f3be143e6596693";